import { gapiCall } from './gapi';

// Request licences by user ID action types 
export const REQUEST_LICENCES = "REQUEST_LICENCES";
export const REQUEST_LICENCES_SUCCESS = "REQUEST_LICENCES_SUCCESS";
export const REQUEST_LICENCES_ERROR = "REQUEST_LICENCES_ERROR";

// Request product licence action types 
export const REQUEST_USER_PRODUCT_LICENCE = "REQUEST_USER_PRODUCT_LICENCE";
export const REQUEST_USER_PRODUCT_LICENCE_SUCCESS = "REQUEST_USER_PRODUCT_LICENCE_SUCCESS";
export const REQUEST_USER_PRODUCT_LICENCE_ERROR = "REQUEST_USER_PRODUCT_LICENCE_ERROR";

/**
 * Request licences by user ID action creator
 * @param {String} userId 
 */
const requestLicences = userId => {
  return {
    type: REQUEST_LICENCES,
    userId
  }
}

/**
 * Request licences by user ID success action creator
 * @param {String} userId 
 * @param {Array} items Array of licences granted to that user
 */
const requestLicencesSuccess = (userId, items) => {
  return {
    type: REQUEST_LICENCES_SUCCESS,
    items,
    userId
  }
}

/**
 * Request licences by user ID error action creator
 * @param {String} userId 
 * @param {Error} error 
 */
const requestLicencesError = (userId, error) => {
  return {
    type: REQUEST_LICENCES_ERROR,
    error,
    userId
  }
}

/**
 * Request licence by user and product action creator
 * @param {String} userId 
 */
const requestUserProductLicence = (userId, productId) => {
  return {
    type: REQUEST_USER_PRODUCT_LICENCE,
    userId
  }
}

/**
 * Request licence by user and product success action creator
 * @param {String} userId 
 * @param {Array} items Array of licences granted to that user
 */
const requestUserProductLicenceSuccess = (userId, productId, licence) => {
  return {
    type: REQUEST_USER_PRODUCT_LICENCE_SUCCESS,
    licence,
    userId,
    productId
  }
}

/**
 * Request licence by user and product error action creator
 * @param {String} userId 
 * @param {Error} error 
 */
const requestUserProductLicenceError = (userId, productId, error) => {
  return {
    type: REQUEST_USER_PRODUCT_LICENCE_ERROR,
    error,
    userId,
    productId
  }
}

/**
 * Fetches licences for a user, 
 * always includes resources consumed as part of the licence
 * @param {String} userId 
 */
export const fetchLicencesByUserId = userId => dispatch =>
  dispatch(requestLicences(userId))
  && dispatch(gapiCall(client => client.billing.users.licences.list({ userId, includes: ["resources"] })))
    .then(res => dispatch(requestLicencesSuccess(userId, res.items)))
    .catch(error => dispatch(requestLicencesError(userId, error)))


/**
 * Fetches licence for a user on a product, 
 * @param {String} userId 
 */
export const fetchUserProductLicence = (userId, productId) => dispatch =>
  dispatch(requestUserProductLicence(userId))
  && dispatch(gapiCall(client => client.billing.products.licences.get({ userId, productId })))
    .then(res => dispatch(requestUserProductLicenceSuccess(userId, productId, res)))
    .catch(error => dispatch(requestUserProductLicenceError(userId, productId, error)))



// WEBPACK FOOTER //
// ./src/actions/licences.js